import CustomerTableForConsolidationRevenue from './CustomerTableForConsolidateRevenue';
import { useGetConsolidateCampaignRevenue } from 'hooks/uesGetConsolidateRevenue';
import { transformDataToTable } from './utils';
import { useMemo } from 'react';
import { GetConsolidateRevenueData, TransformedRevenueData } from 'services/api/type/report.type';
import { useTranslation } from 'react-i18next';

interface UsedRoomsFiltersProps {
  filterOptions: any;
  isEnable: boolean;
  setDataSource: (data: any[]) => void;
}

export default function CampaignTab({
  filterOptions,
  isEnable,
  setDataSource
}: UsedRoomsFiltersProps) {
  const { t } = useTranslation();
  const { data: consolidateRevenue, isLoading } = useGetConsolidateCampaignRevenue(
    filterOptions,
    isEnable
  );

  const dataSource = useMemo(() => {
    if (consolidateRevenue) {
      return transformDataToTable(
        consolidateRevenue as unknown as GetConsolidateRevenueData,
        t
      ) as unknown as TransformedRevenueData[];
    }
    return [];
  }, [consolidateRevenue, t]);

  setDataSource(dataSource);

  return (
    <CustomerTableForConsolidationRevenue
      loading={isLoading}
      dataSource={dataSource}
      title={t('managePage.consolidateRevenueReportPage.common.titleCampaign')}
      filterOptions={filterOptions}
    />
  );
}
